import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { UserRow } from "Classes/GridRows";

@Component({
    selector: "change-password",
    template: require('./change-password.component.html'),
    styles: [require('./change-password.component.css')]
})

export class ChangePasswordComponent implements OnInit {
    constructor() {
    }

    @Input() changePassword: boolean;
    @Input() selectedUser: UserRow;
    @Output() changePasswordChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    ngOnInit(): void {

    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./App/Components/change-password.component.ts